import React, { useState } from 'react';
import { Layout, Button, Row, Col, Typography, Form, Input } from 'antd';
import signinbg from '../assets/images/img-signin.jpg';
import { getToken } from 'src/services/auth.service';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { useHistory } from 'react-router-dom';

const { Title } = Typography;
const { Content } = Layout;

const SignIn = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [, setToken] = useLocalStorage('access_token');
  const history = useHistory();

  const onFinish = async (values) => {
    const { username, password } = values;

    try {
      setLoading(true);
      const token = await getToken({ username, password });
      // Store the token in local storage
      console.log('Token received:', token);
      setToken(token);
      // Redirect to the dashboard
      history.push('/dashboard');
    } catch (error) {
      console.error('Error during sign-in:', error);
      // Set field error on password input
      form.setFields([
        {
          name: 'password',
          errors: ['Sign-in failed. Please check your password.'],
        },
      ]);
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  return (
    <>
      <Layout className='layout-default layout-signin'>
        <Content className='signin'>
          <Row gutter={[24, 0]} justify='space-around'>
            <Col
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 2 }}
              md={{ span: 12 }}
            >
              <Title className='mb-15' level={2}>
                Bitoreum Dashboard
              </Title>
              <Title className='font-regular text-muted' level={5}>
                Enter your password to sign in
              </Title>
              <Form
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout='vertical'
                className='row-col'
              >
                <Form.Item
                  className='username'
                  label='Username'
                  name='username'
                  rules={[
                    {
                      required: true,
                      message: 'Please input your username!',
                    },
                  ]}
                >
                  <Input placeholder='Username' />
                </Form.Item>

                <Form.Item
                  className='username'
                  label='Password'
                  name='password'
                  rules={[
                    {
                      required: true,
                      message: 'Please input your password!',
                    },
                  ]}
                >
                  <Input.Password placeholder='Password' />
                </Form.Item>

                <Form.Item>
                  <Button
                    type='primary'
                    htmlType='submit'
                    style={{ width: '100%' }}
                    loading={loading}
                  >
                    SIGN IN
                  </Button>
                </Form.Item>
              </Form>
            </Col>
            <Col
              className='sign-img'
              style={{ padding: 12 }}
              xs={{ span: 24 }}
              lg={{ span: 12 }}
              md={{ span: 12 }}
            >
              <img src={signinbg} alt='' />
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
};
export default SignIn;
